import * as React from 'react';
import { MaskedTextBox } from '@progress/kendo-react-inputs';
import StreetAddress, { StreetAddressViewModel } from '../StreetAddress';

export type ReleaseViewModel = {
    ReleaseID: number,
    Relation: string;
    FirstName: string;
    LastName: string;
    Phone: string;
    MobilePhone: string;
    Address: StreetAddressViewModel | null;
}

type Props = {
    Validation: boolean;
    release: ReleaseViewModel;
    index: number;
    onChange: (newAddress: ReleaseViewModel) => void;
}

export default class RegistrationRelease extends React.Component<Props>{

    constructor(props: Props) {
        super(props);
    }

    public render() {
        return <React.Fragment>
            <h5>Release Authorization Information</h5>
            <div className="card">
                <div className="card-body">
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <span className="input-group-text">Relationship to Child<div style={{ color: '#dc3545' }}>*</div></span>
                        </div>
                        <input
                            type="text"
                            placeholder="Grandparent, Family Friend, etc"
                            className="form-control"
                            value={this.props.release.Relation}
                            onChange={(e) => this.updateRelease({ Relation: e.target.value })}
                        />
                    </div>
                    {(this.props.Validation && !this.props.release.Relation) ? <p className="error-msg">Relationship is Required</p> : <br/>}
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <span className="input-group-text">Name<div style={{ color: '#dc3545' }}>*</div></span>
                        </div>
                        <label id="name"></label>
                        <input
                            type="string"
                            name="FirstName"
                            placeholder="First Name"
                            className="form-control"
                            value={this.props.release.FirstName}
                            onChange={(e) => this.updateRelease({ FirstName: e.target.value })}
                        />
                        <input
                            type="string"
                            name="LastName"
                            placeholder="Last Name"
                            className="form-control"
                            value={this.props.release.LastName}
                            onChange={(e) => this.updateRelease({ LastName: e.target.value })}
                        />
                    </div>
                    {this.props.Validation && !this.props.release.FirstName && !this.props.release.LastName && <p className="error-msg">First and Last Name are Required</p>}
                    {this.props.Validation && !this.props.release.FirstName && this.props.release.LastName && <p className="error-msg">First Name is Required</p>}
                    {this.props.Validation && this.props.release.FirstName && !this.props.release.LastName && <p className="error-msg">Last Name is Required</p>}
                    {this.props.Validation && this.props.release.FirstName && this.props.release.LastName && <br/> || !this.props.Validation && <br/>}
                    <label>
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text">Cell Phone Number<div style={{ color: '#dc3545' }}>*</div></span>
                            </div>
                            <MaskedTextBox
                                mask="(000)000-0000"
                                name="Cell"
                                placeholder="(000)000-0000"
                                value={this.props.release.MobilePhone || ''}
                                onChange={(e) => this.updateRelease({ MobilePhone: e.target.value})}
                            />
                        </div>
                        {(this.props.Validation && (!this.props.release.MobilePhone || this.props.release.MobilePhone.length < 13)) ? <p className="error-msg">Cell Phone is Required</p> : <br/>}
                    </label>
                    <label>
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text">Phone Number</span>
                            </div>
                            <MaskedTextBox
                                mask="(000)000-0000"
                                name="Phone"
                                placeholder="(000)000-0000"
                                value={this.props.release.Phone || ''}
                                onChange={(e) => this.updateRelease({ Phone: e.target.value.replace(/_/g, "") })}
                            />
                        </div>
                    </label>
                    <br/>
                    <StreetAddress
                        address={this.props.release.Address}
                        onChange={(newAddress) => this.updateRelease({ Address: newAddress })}
                        title="Release Address"
                        validation={this.props.Validation}
                        index={this.props.index}
                    />
                </div>
            </div>
            <br/>
        </React.Fragment>
    }

    private updateRelease(value: Partial<ReleaseViewModel>) {
        const newRelease = Object.assign({}, this.props.release, value);
        this.props.onChange(newRelease);
  }
}
